export const QUESTION = {
  type: "question",
  content: "",
};

export const ANSWER = {
  type: "answer",
  content: "",
};

export const DESTINATION = {
  type: "destination",
  content: "",
};
